export const portfolioMaterialityBreakdownQuery = `
  query PortfolioMaterialityBreakdown(
    $businessCentralId: String!
    $isic: [String!]!
    $countries: [String!]!
    $physicalRiskLevels: [GqlRiskBandLevel!]!
    $dependencyLevels: [GqlRiskBandLevel!]!
    $impactLevels: [GqlRiskBandLevel!]!
    $sonLevels: [GqlSonBandLevel!]!
  ) {
    organisation(businessCentralId: $businessCentralId) {
      portfolioRiskStats(
        isic: $isic
        countries: $countries
        physicalRiskLevels: $physicalRiskLevels
        dependencyLevels: $dependencyLevels
        impactLevels: $impactLevels
        sonLevels: $sonLevels
      ) {
        materialityBreakdown {
          name
          sourceKey
          materialityType
          score
        }
      }
    }
  }
`;

export type PortfolioMaterialityBreakdownResult = {
    organisation: {
        portfolioRiskStats: {
            materialityBreakdown: {
                name: string;
                sourceKey: string;
                materialityType: 'Dependency' | 'Impact';
                score: number | null;
            }[];
        };
    } | null;
};
